import { create } from 'zustand';
import api from '../lib/api';

const readInitial = () => {
    try {
        const token = localStorage.getItem('pp_token');
        const user = JSON.parse(localStorage.getItem('pp_user') || 'null');
        return { token, user };
    } catch {
        return { token: null, user: null };
    }
};

const initial = readInitial();

export const useAuth = create((set, get) => ({
    token: initial.token,
    user: initial.user,
    loading: false,
    error: null,

    login: async (username, password) => {
        set({ loading: true, error: null });
        try {
            const res = await api.post('/auth/login', { username, password });
            localStorage.setItem('pp_token', res.data.access_token);
            localStorage.setItem('pp_user', JSON.stringify(res.data.user));
            set({ token: res.data.access_token, user: res.data.user, loading: false });
            return { ok: true };
        } catch (e) {
            const msg = e.response?.data?.detail || 'Login failed';
            set({ loading: false, error: msg });
            return { ok: false, error: msg };
        }
    },

    register: async (payload) => {
        set({ loading: true, error: null });
        try {
            const res = await api.post('/auth/register', payload);
            localStorage.setItem('pp_token', res.data.access_token);
            localStorage.setItem('pp_user', JSON.stringify(res.data.user));
            set({ token: res.data.access_token, user: res.data.user, loading: false });
            return { ok: true };
        } catch (e) {
            const msg = e.response?.data?.detail || 'Registration failed';
            set({ loading: false, error: msg });
            return { ok: false, error: msg };
        }
    },

    initAdmin: async () => {
        try {
            const res = await api.post('/setup/init-admin');
            return { ok: true, message: res.data.message };
        } catch (e) {
            return {
                ok: false,
                error: e.response?.data?.detail || 'Failed to initialize admin',
            };
        }
    },

    logout: () => {
        localStorage.removeItem('pp_token');
        localStorage.removeItem('pp_user');
        set({ token: null, user: null });
    },

    setUser: (user) => {
        localStorage.setItem('pp_user', JSON.stringify(user));
        set({ user });
    },
}));
